import type { Fest } from "../types";

export const FESTS: Fest[] = [
  {
    id: "inkcarceration",
    name: "Inkcarceration",
    shortName: "Inkcarceration",
    kinds: ["metal", "extreme"],
    region: "Midwest",
    country: "US",
    state: "OH",
    city: "Mansfield",
    venue: "Ohio State Reformatory / Richland County Fairgrounds lot",
    latitude: 40.6272,
    longitude: -82.515,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "hookups", "shuttle"],
    whyGo:
      "America’s rock-and-tattoo weekend on the Shawshank prison grounds. The show is in the yard; the lot is at the county fairgrounds with a shuttle — a real RV-and-tent city, not a parking-lot afterthought.",
    campingNotes:
      "Official campground at Richland County Fairgrounds (~4 miles out). Car+tent and RV sites (30A / 50A and dry). Indoor showers. Early-arrival Thursday. Confirm hang-tag and checkout on inkcarceration.com/camping.",
    tripNotes:
      "2026 ran July 17–19. Next: July 16–18, 2027. I-71 to Mansfield. Festival camping sells out; waitlist is a thing.",
    etiquette:
      "The reformatory is a historic site, not a playground. Lot quiet hours and generator rules are posted. Shuttle, don’t convoy drunk.",
    typical: {
      startMonth: 7,
      startDay: 16,
      endMonth: 7,
      endDay: 19,
      cadence: "daily",
      notes: "Mid-July weekend; camping opens Thursday.",
    },
    seasons: [
      { start: "2026-07-17", end: "2026-07-19", cadence: "daily" },
      { start: "2027-07-16", end: "2027-07-18", cadence: "daily" },
    ],
    officialUrl: "https://inkcarceration.com/",
  },
  {
    id: "rocklahoma",
    name: "Rocklahoma",
    shortName: "Rocklahoma",
    kinds: ["metal"],
    region: "South",
    country: "US",
    state: "OK",
    city: "Pryor",
    venue: "Catch the Fever Festival Grounds",
    latitude: 36.308,
    longitude: -95.317,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Labor Day hard-rock field in Oklahoma: on-site camping is the default, not a side quest. Easy I-44 trip from Tulsa or KC.",
    campingNotes:
      "On-site tent and RV camping. Treat it as dry lot unless you reserved power. Dust, heat, and a long weekend — bring water and shade.",
    tripNotes:
      "Typically Labor Day weekend (August 28–30, 2026). Confirm on rocklahoma.com. Pryor is small; fuel up in Tulsa or Claremore.",
    etiquette:
      "Prairie wind. Stake well. The lot is a neighborhood for four nights.",
    typical: {
      startMonth: 8,
      startDay: 28,
      endMonth: 8,
      endDay: 31,
      cadence: "daily",
      notes: "Labor Day weekend.",
    },
    seasons: [
      { start: "2026-08-28", end: "2026-08-30", cadence: "daily" },
    ],
    officialUrl: "https://www.rocklahoma.com/",
  },
  {
    id: "louder-than-life",
    name: "Louder Than Life",
    shortName: "Louder Than Life",
    kinds: ["metal"],
    region: "Southeast",
    country: "US",
    state: "KY",
    city: "Louisville",
    venue: "Kentucky Exposition Center / Highland Festival Grounds",
    latitude: 38.201,
    longitude: -85.743,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Danny Wimmer’s big Kentucky metal weekend. Expo-center camping makes it one of the more RV-practical US fests on this list.",
    campingNotes:
      "Official on-site camping when offered — RV and tent packages. Louisville hotels if the lot is sold. Confirm the current year’s camping map before you roll a 35-footer.",
    tripNotes:
      "Typically mid-to-late September. I-65 / I-264. Confirm dates on louderthanlifefestival.com.",
    etiquette:
      "Big DWP production. Bag checks, no tailgating in day lots. The campground has its own rules.",
    typical: {
      startMonth: 9,
      startDay: 17,
      endMonth: 9,
      endDay: 20,
      cadence: "daily",
      notes: "September weekend.",
    },
    seasons: [
      { start: "2026-09-17", end: "2026-09-20", cadence: "daily" },
    ],
    officialUrl: "https://louderthanlifefestival.com/",
  },
  {
    id: "welcome-to-rockville",
    name: "Welcome to Rockville",
    shortName: "Rockville",
    kinds: ["metal"],
    region: "Southeast",
    country: "US",
    state: "FL",
    city: "Daytona Beach",
    venue: "Daytona International Speedway",
    latitude: 29.185,
    longitude: -81.0706,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "dry-lot"],
    whyGo:
      "Speedway infield camping plus a huge hard-rock bill. Florida heat is the other headliner.",
    campingNotes:
      "Infield / speedway camping when sold — classic dry lot on asphalt and grass. Shade is DIY. Nearby Daytona RV parks if you need hookups and A/C.",
    tripNotes:
      "Typically May. Confirm on welcometorockville.com. I-95.",
    etiquette:
      "Hydrate. Generators and quiet hours are posted for a reason. The infield is not a private driveway.",
    typical: {
      startMonth: 5,
      startDay: 7,
      endMonth: 5,
      endDay: 10,
      cadence: "daily",
      notes: "May weekend at the speedway.",
    },
    seasons: [
      { start: "2026-05-07", end: "2026-05-10", cadence: "daily" },
    ],
    officialUrl: "https://welcometorockville.com/",
  },
  {
    id: "rock-fest-wisconsin",
    name: "Rock Fest",
    shortName: "Rock Fest Cadott",
    kinds: ["metal"],
    region: "Midwest",
    country: "US",
    state: "WI",
    city: "Cadott",
    venue: "Chippewa Valley Festival Grounds",
    latitude: 44.952,
    longitude: -91.087,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "A proper Wisconsin camping rock fest: rural grounds, the lot is the culture, not an afterthought behind a stadium.",
    campingNotes:
      "On-site camping is the point. RV and tent. Mud if it rains. Cadott is tiny — Chippewa Falls / Eau Claire for groceries.",
    tripNotes:
      "Typically mid-July. Confirm on rock-fest.com.",
    etiquette:
      "Small town, huge weekend. Pack out. Don’t block farm roads.",
    typical: {
      startMonth: 7,
      startDay: 16,
      endMonth: 7,
      endDay: 18,
      cadence: "daily",
      notes: "Mid-July.",
    },
    seasons: [
      { start: "2026-07-16", end: "2026-07-18", cadence: "daily" },
    ],
    officialUrl: "https://www.rock-fest.com/",
  },
  {
    id: "fire-in-the-mountains",
    name: "Fire in the Mountains",
    shortName: "FITM",
    kinds: ["extreme", "pagan", "folk"],
    region: "West",
    country: "US",
    state: "WY",
    city: "Kirwin",
    venue: "Remote Absaroka camp / FITM grounds",
    latitude: 43.876,
    longitude: -109.301,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["on-site-camp", "tent-lot", "dry-lot"],
    whyGo:
      "Black metal, folk, and ritual in the Wyoming mountains. Not a DWP stadium show — a camping gathering where the lot and the stage are the same wilderness.",
    campingNotes:
      "Tent-first, high elevation, rough access. Long rigs are a bad idea. Self-contained, weather-ready, leave-no-trace. Confirm current site — this fest has moved.",
    tripNotes:
      "Typically summer in the Absarokas. 4WD / clearance questions are real. Confirm on fireinthemountains.com before you commit a van.",
    etiquette:
      "No new fire rings, pack out human waste as posted, respect private ranch and forest rules. This is not a beer-bong lot.",
    typical: {
      startMonth: 7,
      startDay: 17,
      endMonth: 7,
      endDay: 20,
      cadence: "daily",
      notes: "Summer mountain weekend; site can change.",
    },
    seasons: [
      { start: "2026-07-17", end: "2026-07-20", cadence: "daily" },
    ],
    officialUrl: "https://www.fireinthemountains.com/",
  },
  {
    id: "free-spirit-gathering",
    name: "Free Spirit Gathering",
    shortName: "Free Spirit",
    kinds: ["pagan", "folk"],
    region: "Northeast",
    country: "US",
    state: "MD",
    city: "Darlington",
    venue: "Camp Ramblewood",
    latitude: 39.639,
    longitude: -76.199,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "A long-running Mid-Atlantic pagan camping gathering: rituals, workshops, and music on wooded land. The lot is the event.",
    campingNotes:
      "Camp Ramblewood tent and some RV. Primitive-leaning. Pre-register. This is a community gathering with gate and consent culture, not a ticket-stub day fest.",
    tripNotes:
      "Typically early August. I-95 to Darlington. Confirm on freespiritgathering.org.",
    etiquette:
      "Consent, quiet hours, no photography of ritual without asking. Pack out glitter that does not belong in a creek.",
    typical: {
      startMonth: 8,
      startDay: 4,
      endMonth: 8,
      endDay: 9,
      cadence: "daily",
      notes: "Early August week.",
    },
    seasons: [
      { start: "2026-08-04", end: "2026-08-09", cadence: "daily" },
    ],
    officialUrl: "https://freespiritgathering.org/",
  },
  {
    id: "heartland-pagan-festival",
    name: "Heartland Pagan Festival",
    shortName: "Heartland",
    kinds: ["pagan", "folk"],
    region: "Midwest",
    country: "US",
    state: "KS",
    city: "McLouth",
    venue: "Gaea Retreat Center",
    latitude: 39.196,
    longitude: -95.208,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Kansas flint-hills pagan camping: music, ritual, and a land-based gathering east of Topeka. RV-possible without a speedway.",
    campingNotes:
      "Gaea Retreat tent and limited RV. Dry camping. Pre-register with the festival. Lawrence / Topeka for supplies.",
    tripNotes:
      "Typically Memorial Day / late May. Confirm on heartlandfestival.org or the current organizer page.",
    etiquette:
      "Private retreat land. Closed gates, quiet hours, no uninvited drone shots of ritual.",
    typical: {
      startMonth: 5,
      startDay: 21,
      endMonth: 5,
      endDay: 25,
      cadence: "daily",
      notes: "Late May camping gathering.",
    },
    seasons: [
      { start: "2026-05-21", end: "2026-05-25", cadence: "daily" },
    ],
    officialUrl: "https://www.heartlandfestival.org/",
  },
  {
    id: "starwood-festival",
    name: "Starwood Festival",
    shortName: "Starwood",
    kinds: ["pagan", "folk"],
    region: "Northeast",
    country: "US",
    state: "NY",
    city: "Sherman",
    venue: "Brushwood Folklore Center",
    latitude: 42.16,
    longitude: -79.556,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "A classic Northeastern pagan/folk camping fest on private land. Brushwood also hosts Sirius Rising — same lot culture, different week.",
    campingNotes:
      "Brushwood tent and RV. Land rules are the law. Sherman is rural; bring cash and water plans.",
    tripNotes:
      "Typically mid-July. I-86 / I-90 corridor. Confirm on brushwood.com.",
    etiquette:
      "Clothing-optional areas exist — read the map. Consent culture. No photos of people who didn’t agree.",
    typical: {
      startMonth: 7,
      startDay: 14,
      endMonth: 7,
      endDay: 20,
      cadence: "daily",
      notes: "Mid-July week.",
    },
    seasons: [
      { start: "2026-07-14", end: "2026-07-20", cadence: "daily" },
    ],
    officialUrl: "https://www.brushwood.com/",
  },
  {
    id: "rites-of-spring",
    name: "Rites of Spring",
    shortName: "Rites of Spring",
    kinds: ["pagan", "folk"],
    region: "Northeast",
    country: "US",
    state: "MA",
    city: "Western Massachusetts",
    venue: "EarthSpirit community land (site posted to registrants)",
    latitude: 42.45,
    longitude: -72.65,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["on-site-camp", "tent-lot"],
    whyGo:
      "EarthSpirit’s spring camping gathering: music, ritual, and a New England woods lot. Smaller and more intentional than a metal open air.",
    campingNotes:
      "Tent camping; RVs usually a poor fit. Registration required. Directions often go out to attendees, not to random day-trippers.",
    tripNotes:
      "Typically late May. Confirm on earthspirit.org. Pair with a Berkshires camp if you need a van pad off-site.",
    etiquette:
      "Private spiritual gathering. No press, no uninvited cameras, pack out.",
    typical: {
      startMonth: 5,
      startDay: 20,
      endMonth: 5,
      endDay: 25,
      cadence: "daily",
      notes: "Late May.",
    },
    seasons: [
      { start: "2026-05-20", end: "2026-05-25", cadence: "daily" },
    ],
    officialUrl: "https://www.earthspirit.org/",
  },
  {
    id: "aqua-blues-san-marcos",
    name: "Aqua Blues Music & Art Fest",
    shortName: "Aqua Blues",
    kinds: ["folk"],
    region: "South",
    country: "US",
    state: "TX",
    city: "San Marcos",
    venue: "Downtown San Marcos / Park Plaza",
    latitude: 29.8826,
    longitude: -97.9398,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly"],
    whyGo:
      "The music-and-art half of Mermaid Capital weekend — river town, outdoor stage, Hill Country overnight. Seed of the SMTX circuit, not a 80,000-person German field.",
    campingNotes:
      "Downtown is day-use. Wimberley, Canyon Lake, and San Marcos RV parks. Palmetto State Park if you want quiet.",
    tripNotes:
      "Tied to Mermaid Capital of Texas Fest. 2026 postponed. Next: May 1, 2027 (promenade + Aqua Blues) inside April 23–May 2 citywide dates. Confirm on mermaidsocietysmtx.com/festivalinfo.",
    etiquette:
      "River first. Glitter stays out of the San Marcos. Neighborhood downtown, not a speedway infield.",
    typical: {
      startMonth: 5,
      startDay: 1,
      endMonth: 5,
      endDay: 1,
      cadence: "single",
      notes: "Early May Saturday; 2026 skipped.",
    },
    seasons: [
      { start: "2027-05-01", end: "2027-05-01", cadence: "single" },
    ],
    officialUrl: "https://www.mermaidsocietysmtx.com/festivalinfo",
  },
  {
    id: "salmonfest-alaska",
    name: "Salmonfest",
    shortName: "Salmonfest",
    kinds: ["folk"],
    region: "Alaska",
    country: "US",
    state: "AK",
    city: "Ninilchik",
    venue: "Kenai Peninsula Fairgrounds / Arches Amphitheater",
    latitude: 60.0397,
    longitude: -151.6689,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "shuttle"],
    whyGo:
      "Alaska’s big Kenai camping weekend: jam, folk, and Americana on the fairgrounds with salmon-run politics in the background. The lot is the point.",
    campingNotes:
      "ARCHES on-site camping (tents, vans, RVs) sells out in hours. Overflow along the Sterling with a courtesy shuttle: Volcano View, Deep Creek, Ninilchik View, Alaskan Angler. Dry-lot honesty; fill water before you roll.",
    tripNotes:
      "July 31–August 2, 2026 (15th anniversary). Anchorage then Seward Highway / Sterling Highway to Ninilchik. Confirm on salmonfestalaska.org. Camping opens Thursday evening.",
    etiquette:
      "Wildlife is not a photo op that wants your cooler. Bear-aware food storage. Generators and quiet hours are posted for a reason.",
    typical: {
      startMonth: 7,
      startDay: 31,
      endMonth: 8,
      endDay: 2,
      cadence: "daily",
      notes: "Last weekend of July / first of August.",
    },
    seasons: [
      { start: "2026-07-31", end: "2026-08-02", cadence: "daily" },
    ],
    officialUrl: "https://salmonfestalaska.org/",
  },
  {
    id: "girdwood-forest-fair",
    name: "Girdwood Forest Fair",
    shortName: "Forest Fair",
    kinds: ["folk"],
    region: "Alaska",
    country: "US",
    state: "AK",
    city: "Girdwood",
    venue: "Forest Fair Park",
    latitude: 60.9647,
    longitude: -149.1317,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["on-site-camp", "tent-lot", "shuttle"],
    whyGo:
      "Fifty years of free music, crafts, and a Chugach valley parade. Four stages in the trees; the Anchorage-weekend pin that is not a speedway.",
    campingNotes:
      "Walk-in tent camping only on Karolius Road behind the park — no RVs, no generators, no campfires. Shuttle from Anchorage University Center. Alyeska parking is a mile out. Public camping elsewhere in the valley is prohibited that weekend.",
    tripNotes:
      "July 3–5, 2026. Seward Highway to Girdwood. Confirm on girdwoodforestfair.com. Campground Thursday afternoon through Sunday afternoon.",
    etiquette:
      "No dogs, no politics booths, no religious orders — their signs, not ours. Pack out micro-trash. Bears read coolers.",
    typical: {
      startMonth: 7,
      startDay: 3,
      endMonth: 7,
      endDay: 5,
      cadence: "daily",
      notes: "Independence Day weekend.",
    },
    seasons: [
      { start: "2026-07-03", end: "2026-07-05", cadence: "daily" },
    ],
    officialUrl: "https://girdwoodforestfair.com/",
  },
  {
    id: "six-mile-creek-bluegrass",
    name: "Six Mile Creek Whitewater & Bluegrass Festival",
    shortName: "Six Mile Creek",
    kinds: ["folk"],
    region: "Alaska",
    country: "US",
    state: "AK",
    city: "Hope",
    venue: "Mile 3.4 Hope Highway / Sixmile Creek, Chugach National Forest",
    latitude: 60.838,
    longitude: -149.098,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["on-site-camp", "tent-lot"],
    whyGo:
      "A free last-Saturday-of-July creek gathering: mass-start kayak, packraft, and pool-toy races through Sixmile’s first canyon, then bluegrass on the shore until the fire show. Nineteen years in, still donation-pass, not a ticket booth.",
    campingNotes:
      "Dispersed tent camping behind the main stage and around mile 1. No motorhomes, trailers, or buses — truck campers and vans only, fully off the white line or you get towed. No trash cans, no cell service. Pack out every butt and can; this is a Forest Service permit, not a fairgrounds pad.",
    tripNotes:
      "Typically the last Saturday of July (July 25, 2026). Seward Highway to Hope Highway; look for signs at mile 3.4. Races ~1pm back toward the Seward junction. Details land annually on social / adventurebuddy — there is no box-office site. Donate; the whole thing is free because people do.",
    etiquette:
      "Whitewater gear is required in the river (helmet, PFD, drytop/drysuit). Porta-potties exist — use them. Do not block the dirt loop at the toilets; ambulances need the turnaround. Leave the forest cleaner than you found it or there is no next year.",
    typical: {
      startMonth: 7,
      startDay: 25,
      endMonth: 7,
      endDay: 25,
      cadence: "single",
      notes: "Last Saturday of July; people camp the night.",
    },
    seasons: [
      { start: "2026-07-25", end: "2026-07-25", cadence: "single" },
    ],
    officialUrl: "https://adventurebuddy.com/adventures/six-mile-creek-whitewater-bluegrass-festival/",
  },
  {
    id: "loud-as-hell",
    name: "Loud as Hell Open Air",
    shortName: "Loud as Hell",
    kinds: ["metal", "extreme"],
    region: "Canada",
    country: "CA",
    state: "AB",
    city: "Drumheller",
    venue: "Dinosaur Downs Speedway",
    latitude: 51.455,
    longitude: -112.71,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Alberta’s camping metal weekend in the badlands. Face-melting bill, pancake breakfasts, and a dry lot under a huge sky — the prairie answer to a European open air.",
    campingNotes:
      "On-site tent field plus a camper/RV/trailer lot. No hookups; generators welcome. Family camping is a separate quieter patch. Camping opens Thursday. Ticket includes camping.",
    tripNotes:
      "July 31–August 2, 2026. Calgary then Hwy 9 to Drumheller. Thursday kickoff at Neighbours’ Corner Pub (18+). Confirm on loudashell.ca.",
    etiquette:
      "Fire bans are real in July. Above-ground or propane pits only. Kids are welcome; the pit is not a babysitter.",
    typical: {
      startMonth: 7,
      startDay: 31,
      endMonth: 8,
      endDay: 2,
      cadence: "daily",
      notes: "Late July / early August weekend.",
    },
    seasons: [
      { start: "2026-07-31", end: "2026-08-02", cadence: "daily" },
    ],
    officialUrl: "https://loudashell.ca/",
  },
  {
    id: "big-valley-jamboree",
    name: "Big Valley Jamboree",
    shortName: "BVJ",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "AB",
    city: "Camrose",
    venue: "Camrose Regional Exhibition",
    latitude: 53.0166,
    longitude: -112.8288,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Canada’s classic prairie country camping city. Named sites, a Main Street, and a four-day lot — as RV-practical as a North American music weekend gets.",
    campingNotes:
      "Purchased primitive sites (20×40 and oversized). No services on the pad; water haul and showers exist. Early arrival Wednesday. RV drop-off passes for delivery drivers. Renewals lock next year’s same site.",
    tripNotes:
      "July 30–August 2, 2026. Edmonton then Hwy 21 / 13 to Camrose. Confirm on bigvalleyjamboree.com.",
    etiquette:
      "Gates close 10pm — do not roll in after. Quiet hours differ by campground. The pad is a neighborhood for four nights.",
    typical: {
      startMonth: 7,
      startDay: 30,
      endMonth: 8,
      endDay: 2,
      cadence: "daily",
      notes: "Alberta Civic Holiday weekend.",
    },
    seasons: [
      { start: "2026-07-30", end: "2026-08-02", cadence: "daily" },
    ],
    officialUrl: "https://www.bigvalleyjamboree.com/",
  },
  {
    id: "boots-and-hearts",
    name: "Boots and Hearts",
    shortName: "Boots and Hearts",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "ON",
    city: "Oro-Medonte",
    venue: "Burl's Creek Event Grounds",
    latitude: 44.507,
    longitude: -79.513,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "hookups"],
    whyGo:
      "Canada’s largest music-and-camping weekend: country headliners, themed campgrounds, and a real RV/tent city north of Barrie — the lot is half the ticket.",
    campingNotes:
      "On-site general, car-camp, walk-in, and powered sites. Showers and wash-blocks. Camping usually opens the day before the bill. Cashless venue — cards, not a coffee-can.",
    tripNotes:
      "August 7–9, 2026. Hwy 11 / Ridge Road; do not invent an entrance off Line 8 from the highway. Confirm on bootsandhearts.com.",
    etiquette:
      "45,000 neighbors. Quiet hours and generator rules are posted. Lake Simcoe is 15 minutes if you need a reset, not a drunk swim at 3am.",
    typical: {
      startMonth: 8,
      startDay: 7,
      endMonth: 8,
      endDay: 9,
      cadence: "daily",
      notes: "Early August weekend.",
    },
    seasons: [
      { start: "2026-08-07", end: "2026-08-09", cadence: "daily" },
    ],
    officialUrl: "https://www.bootsandhearts.com/",
  },
  {
    id: "kaleidoscope-gathering",
    name: "Kaleidoscope Gathering",
    shortName: "KG",
    kinds: ["pagan", "folk"],
    region: "Canada",
    country: "CA",
    state: "ON",
    city: "Eganville",
    venue: "Raven's Knoll, Highway 60 / Golden Lake",
    latitude: 45.5725,
    longitude: -77.3278,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Canada’s biggest pagan camping gathering: Lughnasadh week on 105 acres with a Bonnechere River beach. Rituals, workshops, and a lot that is the event.",
    campingNotes:
      "First-come tent and RV on Raven’s Knoll — no reserved pads. Registration required. Ottawa / Hwy 60. This is a closed-gate community gathering, not a day-ticket faire.",
    tripNotes:
      "July 29–August 3, 2026 (theme: Seasons). Confirm on kg.ravensknoll.ca. Eganville for fuel and ice.",
    etiquette:
      "Consent culture. No photography of ritual without asking. Private spiritual land — pack out, stay off workshop spaces.",
    typical: {
      startMonth: 7,
      startDay: 29,
      endMonth: 8,
      endDay: 3,
      cadence: "daily",
      notes: "August long-weekend week.",
    },
    seasons: [
      { start: "2026-07-29", end: "2026-08-03", cadence: "daily" },
    ],
    officialUrl: "https://kg.ravensknoll.ca/",
  },
  {
    id: "winnipeg-folk-festival",
    name: "Winnipeg Folk Festival",
    shortName: "Winnipeg Folk",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "MB",
    city: "Birds Hill",
    venue: "Birds Hill Provincial Park",
    latitude: 50.0295,
    longitude: -96.934,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "shuttle"],
    whyGo:
      "Four days of folk in a provincial park north of Winnipeg. Festival Campground and Quiet Campground are the overnight; the stages are the day.",
    campingNotes:
      "Camping sold with the 4-day ticket. Limited unserviced RV/trailer permits — buy them when tickets drop or join the waitlist. Park pass required (manitobaelicensing.ca). Cold showers, water taps, campground store.",
    tripNotes:
      "July 9–12, 2026; 2027 is July 8–11. West Gate of Birds Hill. Confirm on winnipegfolkfestival.ca. Mosquitoes are a headliner.",
    etiquette:
      "Quiet Campground wristbands cannot enter Festival Campground. Glass stays home. Leave a foot of space around the tent for first responders.",
    typical: {
      startMonth: 7,
      startDay: 9,
      endMonth: 7,
      endDay: 12,
      cadence: "daily",
      notes: "Second weekend in July.",
    },
    seasons: [
      { start: "2026-07-09", end: "2026-07-12", cadence: "daily" },
      { start: "2027-07-08", end: "2027-07-11", cadence: "daily" },
    ],
    officialUrl: "https://www.winnipegfolkfestival.ca/",
  },
  {
    id: "sunfest-laketown",
    name: "Sunfest Country",
    shortName: "Sunfest",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "BC",
    city: "Lake Cowichan",
    venue: "Laketown Ranch / Laketown Amphitheatre",
    latitude: 48.8544,
    longitude: -124.1747,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Vancouver Island country camping on a ranch amphitheatre. Infield RV pads, oversized bus lots, and a forested upper camp — the Island lot for people who brought the rig.",
    campingNotes:
      "Festival wristband plus camping wristband. Infield 20×34 for RV/trailer/tent; Big Boy’s Toys for buses. No on-site water refill — fill before Youbou Road. Generators off midnight–8am. Checkout Monday 11am.",
    tripNotes:
      "July 30–August 2, 2026. Nanaimo or Victoria ferry, then Cowichan Valley to Youbou. Confirm on laketownranch.com. Thursday early-entry is a separate pass.",
    etiquette:
      "No wood fires or charcoal. Propane 12 inches off the ground and a fire extinguisher at the site. Island fire bans are not a vibe check.",
    typical: {
      startMonth: 7,
      startDay: 30,
      endMonth: 8,
      endDay: 2,
      cadence: "daily",
      notes: "BC Day long weekend.",
    },
    seasons: [
      { start: "2026-07-30", end: "2026-08-02", cadence: "daily" },
    ],
    officialUrl: "https://www.laketownranch.com/",
  },
  {
    id: "kluane-mountain-bluegrass",
    name: "Kluane Mountain Bluegrass Festival",
    shortName: "Kluane Bluegrass",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "YT",
    city: "Haines Junction",
    venue: "St. Elias Convention Centre",
    latitude: 60.7528,
    longitude: -137.5107,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "nearby-camp"],
    whyGo:
      "The only bluegrass festival north of 60: village-scale concerts, jams, and a Kluane backdrop. The Yukon pin so the map is not only the lower 48.",
    campingNotes:
      "Pre-register tent and RV camping at the convention centre (free when offered). Overflow: FasGas RV Park in town, Pine Lake Territorial, Kathleen Lake in Kluane National Park. Whitehorse is the airport and the grocery run.",
    tripNotes:
      "June 12–14, 2026. Alaska Highway / Haines Highway to Dakwäkäda. Confirm on yukonbluegrass.com. Midnight-sun evenings; pack layers.",
    etiquette:
      "Champagne and Aishihik First Nations land. Village quiet hours. Do not treat the convention lawn like a Wacken infield.",
    typical: {
      startMonth: 6,
      startDay: 12,
      endMonth: 6,
      endDay: 14,
      cadence: "daily",
      notes: "Mid-June weekend.",
    },
    seasons: [
      { start: "2026-06-12", end: "2026-06-14", cadence: "daily" },
    ],
    officialUrl: "https://yukonbluegrass.com/",
  },
  {
    id: "folk-on-the-rocks",
    name: "Folk on the Rocks",
    shortName: "Folk on the Rocks",
    kinds: ["folk"],
    region: "Canada",
    country: "CA",
    state: "NT",
    city: "Yellowknife",
    venue: "Long Lake festival grounds",
    latitude: 62.4542,
    longitude: -114.3715,
    overnight: "nearby",
    rvFriendly: true,
    tags: ["nearby-camp", "rv-friendly", "shuttle"],
    whyGo:
      "Midnight-sun folk on a Canadian Shield lakeshore. Northern and visiting bills, Dene drummers, and a weekend that is worth the fly-in.",
    campingNotes:
      "No on-site camping. Fred Henne Territorial Park is the closest overnight (RV and tent) a short drive down Highway 3. Book nwtparks.ca. Festival buses run from town; bikes lock at the gate.",
    tripNotes:
      "July 17–19, 2026; next is July 15–18, 2027. Fly Yellowknife (YZF). Confirm on folkontherocks.com. Bugs and 24-hour light — a sleep mask is gear.",
    etiquette:
      "Lakeshore is not a dumpster. Glass is a hazard in the sand. Indigenous programming is not a costume opportunity.",
    typical: {
      startMonth: 7,
      startDay: 17,
      endMonth: 7,
      endDay: 19,
      cadence: "daily",
      notes: "Mid-July weekend.",
    },
    seasons: [
      { start: "2026-07-17", end: "2026-07-19", cadence: "daily" },
      { start: "2027-07-15", end: "2027-07-18", cadence: "daily" },
    ],
    officialUrl: "https://www.folkontherocks.com/",
  },
  {
    id: "wacken-open-air",
    name: "Wacken Open Air",
    shortName: "Wacken",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "DE",
    state: "SH",
    city: "Wacken",
    venue: "Wacken festival grounds",
    latitude: 54.487,
    longitude: 9.375,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "The metal lot. A village of 1,800 becomes a city of 85,000. Camping is not optional culture — it is the pilgrimage.",
    campingNotes:
      "Camping included with the festival ticket. Tent city plus camper/RV areas. Mud is a personality. Hamburg (HAM) then train/shuttle. Treat the lot as a week, not a night.",
    tripNotes:
      "July 29 – August 1, 2026 (grounds wake up earlier in the week). Confirm on wacken.com. Tickets sell on reputation.",
    etiquette:
      "The Holy Ground rules: no glass in stupid places, respect crew, pack your trash. Wacken is a working farm the other 51 weeks.",
    typical: {
      startMonth: 7,
      startDay: 29,
      endMonth: 8,
      endDay: 1,
      cadence: "daily",
      notes: "Late July; arrive early in the week.",
    },
    seasons: [
      { start: "2026-07-29", end: "2026-08-01", cadence: "daily" },
    ],
    officialUrl: "https://www.wacken.com/",
  },
  {
    id: "hellfest",
    name: "Hellfest",
    shortName: "Hellfest",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "FR",
    state: "44",
    city: "Clisson",
    venue: "Val de Moine, Clisson",
    latitude: 47.087,
    longitude: -1.283,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "The other European pillar: four days, extreme through classic, Loire wine country, camping included. Wider bill than Wacken, same lot energy.",
    campingNotes:
      "On-site camping with the pass. Nantes is the city/airport. Camper vans work; giant US Class As are a European-lane problem.",
    tripNotes:
      "June 18–21, 2026. Confirm on hellfest.fr. Passes can vanish in minutes.",
    etiquette:
      "French festival rules, bag checks, heat. The village of Clisson is not your dumpster.",
    typical: {
      startMonth: 6,
      startDay: 18,
      endMonth: 6,
      endDay: 21,
      cadence: "daily",
      notes: "Mid-June.",
    },
    seasons: [
      { start: "2026-06-18", end: "2026-06-21", cadence: "daily" },
    ],
    officialUrl: "https://www.hellfest.fr/",
  },
  {
    id: "graspop",
    name: "Graspop Metal Meeting",
    shortName: "Graspop",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "BE",
    state: "VAN",
    city: "Dessel",
    venue: "Graspop festival site",
    latitude: 51.238,
    longitude: 5.114,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Belgian metal camping: organized lots, easy travel from Eindhoven/Antwerp/Brussels, a bill that sits between Wacken spectacle and club extremity.",
    campingNotes:
      "Camping included / add-on packages. Camper area. Flat, crowded, well-run. Eindhoven (EIN) is a common fly-in.",
    tripNotes:
      "June 18–21, 2026. Confirm on graspop.be.",
    etiquette:
      "Benelux festival manners. Recycling is not optional theater.",
    typical: {
      startMonth: 6,
      startDay: 18,
      endMonth: 6,
      endDay: 21,
      cadence: "daily",
      notes: "Same mid-June weekend as Hellfest some years — pick one lot.",
    },
    seasons: [
      { start: "2026-06-18", end: "2026-06-21", cadence: "daily" },
    ],
    officialUrl: "https://www.graspop.be/",
  },
  {
    id: "brutal-assault",
    name: "Brutal Assault",
    shortName: "Brutal Assault",
    kinds: ["extreme"],
    region: "Europe",
    country: "CZ",
    state: "KR",
    city: "Jaroměř",
    venue: "Josefov Fortress",
    latitude: 50.339,
    longitude: 15.929,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Death, black, grind, and hardcore inside an Austro-Hungarian fortress. The camping is next to the walls. This is the extreme-lot trip.",
    campingNotes:
      "On-site tent camping is standard; camper vans work with care. Fortress town, not a farm field. Prague is the airport.",
    tripNotes:
      "August 5–8, 2026. Confirm on brutalassault.cz.",
    etiquette:
      "Fortress masonry is not a climbing wall. Support the town of Jaroměř; it hosts the circus.",
    typical: {
      startMonth: 8,
      startDay: 5,
      endMonth: 8,
      endDay: 8,
      cadence: "daily",
      notes: "Early August.",
    },
    seasons: [
      { start: "2026-08-05", end: "2026-08-08", cadence: "daily" },
    ],
    officialUrl: "https://brutalassault.cz/",
  },
  {
    id: "summer-breeze",
    name: "Summer Breeze Open Air",
    shortName: "Summer Breeze",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "DE",
    state: "BY",
    city: "Dinkelsbühl",
    venue: "Summer Breeze festival grounds",
    latitude: 49.07,
    longitude: 10.319,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Franconian metal camping: less circus than Wacken, more bands-per-mud. The lot is still the stay.",
    campingNotes:
      "Camping tied to the festival ticket. Camper area. Dinkelsbühl is a real town — groceries exist. Nuremberg is the useful airport.",
    tripNotes:
      "August 12–15, 2026. Confirm on summer-breeze.de. Full tickets (with camping) sell separately from day tickets.",
    etiquette:
      "Bavarian festival rules. Quiet hours toward the town edge.",
    typical: {
      startMonth: 8,
      startDay: 12,
      endMonth: 8,
      endDay: 15,
      cadence: "daily",
      notes: "Mid-August.",
    },
    seasons: [
      { start: "2026-08-12", end: "2026-08-15", cadence: "daily" },
    ],
    officialUrl: "https://www.summer-breeze.de/",
  },
  {
    id: "party-san",
    name: "Party.San Open Air",
    shortName: "Party.San",
    kinds: ["extreme"],
    region: "Europe",
    country: "DE",
    state: "TH",
    city: "Schlotheim",
    venue: "Obermehler airfield",
    latitude: 51.246,
    longitude: 10.658,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot", "dry-lot"],
    whyGo:
      "Death and black metal on a Thuringian airfield. No mainstream day-ticket energy. The field is the festival.",
    campingNotes:
      "On-site camping. Dry, windy, industrial-field lot. Bring your own shade and water plan.",
    tripNotes:
      "August 13–15, 2026. Confirm on party-san.de. Leipzig / Erfurt airports.",
    etiquette:
      "Extreme-metal crowd, still not a war zone. Respect the airfield as working land.",
    typical: {
      startMonth: 8,
      startDay: 13,
      endMonth: 8,
      endDay: 15,
      cadence: "daily",
      notes: "Mid-August.",
    },
    seasons: [
      { start: "2026-08-13", end: "2026-08-15", cadence: "daily" },
    ],
    officialUrl: "https://www.party-san.de/",
  },
  {
    id: "midgardsblot",
    name: "Midgardsblot",
    shortName: "Midgardsblot",
    kinds: ["pagan", "folk", "metal"],
    region: "Europe",
    country: "NO",
    state: "VE",
    city: "Horten",
    venue: "Borre burial mounds / Midgard Viking Centre",
    latitude: 59.382,
    longitude: 10.467,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Viking-age mounds, folk, pagan, and metal. The Norwegian lot for people who want ritual and riffs in the same field.",
    campingNotes:
      "Official camping next to the site. Tent-heavy; camper vans possible. Oslo is the fly-in. This is not a German 80k city — smaller, archaeological, weather-honest.",
    tripNotes:
      "Typically August. Confirm on midgardsblot.no.",
    etiquette:
      "Burial mounds are not a merch booth. Stay off earthworks, no metal detecting, pack out.",
    typical: {
      startMonth: 8,
      startDay: 12,
      endMonth: 8,
      endDay: 16,
      cadence: "daily",
      notes: "Mid-August.",
    },
    seasons: [
      { start: "2026-08-12", end: "2026-08-16", cadence: "daily" },
    ],
    officialUrl: "https://www.midgardsblot.no/",
  },
  {
    id: "bloodstock",
    name: "Bloodstock Open Air",
    shortName: "Bloodstock",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "GB",
    state: "ENG",
    city: "Walton-on-Trent",
    venue: "Caton Hall",
    latitude: 52.76,
    longitude: -1.682,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "The UK’s metal camping fest that still feels like metal. Caton Hall fields, weekend lot, Birmingham-adjacent.",
    campingNotes:
      "Weekend camping with the ticket. Car parks and camper fields. East Midlands mud. Don’t expect US-style 50A pedestals.",
    tripNotes:
      "Typically August. Confirm on bloodstock.uk.com. EMA / BHX airports.",
    etiquette:
      "UK festival security and bag policy. The village of Walton is not the campsite.",
    typical: {
      startMonth: 8,
      startDay: 6,
      endMonth: 8,
      endDay: 9,
      cadence: "daily",
      notes: "August weekend.",
    },
    seasons: [
      { start: "2026-08-06", end: "2026-08-09", cadence: "daily" },
    ],
    officialUrl: "https://www.bloodstock.uk.com/",
  },
  {
    id: "download-uk",
    name: "Download Festival",
    shortName: "Download",
    kinds: ["metal"],
    region: "Europe",
    country: "GB",
    state: "ENG",
    city: "Castle Donington",
    venue: "Donington Park",
    latitude: 52.83,
    longitude: -1.375,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "The UK rock-and-metal city on the Donington infield. Bigger, messier, still a lot you sleep on.",
    campingNotes:
      "Official camping villages. Campervan fields cost extra. East Midlands Airport is next door. Mud is not a rumor.",
    tripNotes:
      "Typically June. Confirm on downloadfestival.co.uk.",
    etiquette:
      "Huge site. Follow fire-lane rules in the van field or you get towed in front of 80,000 people.",
    typical: {
      startMonth: 6,
      startDay: 12,
      endMonth: 6,
      endDay: 14,
      cadence: "daily",
      notes: "June weekend.",
    },
    seasons: [
      { start: "2026-06-12", end: "2026-06-14", cadence: "daily" },
    ],
    officialUrl: "https://downloadfestival.co.uk/",
  },
  {
    id: "mera-luna",
    name: "M'era Luna",
    shortName: "M'era Luna",
    kinds: ["goth", "metal"],
    region: "Europe",
    country: "DE",
    state: "NI",
    city: "Hildesheim",
    venue: "Flugplatz Hildesheim",
    latitude: 52.18,
    longitude: 9.946,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Goth, wave, and dark metal on a German airfield. The camping weekend for people who want black lipstick and a pegged tent, not a downtown club crawl.",
    campingNotes:
      "On-site camping. Airfield wind. Hannover is the city. Camper vans yes; US toy-haulers no.",
    tripNotes:
      "Typically August. Confirm on meraluna.de.",
    etiquette:
      "Dark-scene consent and cameras. The airfield is borrowed land.",
    typical: {
      startMonth: 8,
      startDay: 8,
      endMonth: 8,
      endDay: 9,
      cadence: "daily",
      notes: "August weekend.",
    },
    seasons: [
      { start: "2026-08-08", end: "2026-08-09", cadence: "daily" },
    ],
    officialUrl: "https://www.meraluna.de/",
  },
  {
    id: "sweden-rock",
    name: "Sweden Rock Festival",
    shortName: "Sweden Rock",
    kinds: ["metal"],
    region: "Europe",
    country: "SE",
    state: "K",
    city: "Sölvesborg",
    venue: "Norje festival grounds",
    latitude: 56.052,
    longitude: 14.617,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Hard rock and metal on the Blekinge coast with a serious camping village. Scandinavian lot, long daylight in June.",
    campingNotes:
      "On-site camping and camper areas. Copenhagen (CPH) is the usual fly-in plus a train/bus. Bring a sleeping mask for June sun.",
    tripNotes:
      "Typically early June (2027: June 9–12 listed in some calendars). Confirm on swedenrock.com.",
    etiquette:
      "Swedish recycling and quiet-hour culture. The Baltic is cold; the beer is not an excuse to swim drunk.",
    typical: {
      startMonth: 6,
      startDay: 3,
      endMonth: 6,
      endDay: 6,
      cadence: "daily",
      notes: "Early June.",
    },
    seasons: [
      { start: "2026-06-03", end: "2026-06-06", cadence: "daily" },
    ],
    officialUrl: "https://www.swedenrock.com/",
  },
  {
    id: "tolminator",
    name: "Tolminator",
    shortName: "Tolminator",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "SI",
    state: "SI",
    city: "Tolmin",
    venue: "Soca riverbank festival site",
    latitude: 46.183,
    longitude: 13.733,
    overnight: "on-site",
    rvFriendly: true,
    tags: ["on-site-camp", "rv-friendly", "tent-lot"],
    whyGo:
      "Metal on the Soča: swim between sets, camp on the riverbank. The successor energy to Metaldays on the same valley.",
    campingNotes:
      "On-site camping by the river. Alpine weather. Ljubljana airport then a winding drive. Vans yes; huge coaches struggle the last road.",
    tripNotes:
      "July 24–28, 2026. Confirm on the current Tolminator / Soča festival page.",
    etiquette:
      "The river is the jewel. No soap in the Soča, no drones over swimmers, pack out.",
    typical: {
      startMonth: 7,
      startDay: 24,
      endMonth: 7,
      endDay: 28,
      cadence: "daily",
      notes: "Late July.",
    },
    seasons: [
      { start: "2026-07-24", end: "2026-07-28", cadence: "daily" },
    ],
    officialUrl: "https://www.tolminator.com/",
  },
  {
    id: "copenhell",
    name: "Copenhell",
    shortName: "Copenhell",
    kinds: ["metal", "extreme"],
    region: "Europe",
    country: "DK",
    state: "DK",
    city: "Copenhagen",
    venue: "Refshaleøen",
    latitude: 55.695,
    longitude: 12.617,
    overnight: "on-site",
    rvFriendly: false,
    tags: ["on-site-camp", "tent-lot", "shuttle"],
    whyGo:
      "Industrial-island metal in Copenhagen with official camping. More urban than Wacken, still a lot you sleep on if you book it.",
    campingNotes:
      "Official tent camping on/near Refshaleøen when offered. RVs are a Copenhagen problem — use the tent lot or a city campground. Book early.",
    tripNotes:
      "Typically mid-June. Confirm on copenhell.dk. CPH airport, then metro/bus/boat.",
    etiquette:
      "City-island festival. Neighbors exist. Danish waste rules are not a suggestion.",
    typical: {
      startMonth: 6,
      startDay: 17,
      endMonth: 6,
      endDay: 20,
      cadence: "daily",
      notes: "Mid-June.",
    },
    seasons: [
      { start: "2026-06-17", end: "2026-06-20", cadence: "daily" },
    ],
    officialUrl: "https://copenhell.dk/",
  },
];

export function festById(id: string): Fest | undefined {
  return FESTS.find((fest) => fest.id === id);
}

export const REGIONS: Array<Fest["region"]> = [
  "Northeast",
  "Southeast",
  "Midwest",
  "South",
  "Southwest",
  "West",
  "Alaska",
  "Canada",
  "Europe",
];

export const KINDS: Array<Fest["kinds"][number]> = [
  "extreme",
  "metal",
  "pagan",
  "goth",
  "folk",
];
